module.exports = __webpack_public_path__ + "media/src/assets/nav_logo-2f0eeb507460696ed6ca166f1ad15c53.png";